import classNames from 'classnames';
import styles from './SortableTableHeader.module.scss';

export enum SortDirection {
	Descending = -1,
	Ascending = 1,
}

export interface SortableTableHeaderProps {
	compact?: boolean;
	sorted?: boolean;
	sortDirection?: SortDirection;
	children: React.ReactNode;
	onClick: () => void;
}

export const SortableTableHeader: React.FC<SortableTableHeaderProps> = ({ compact = false, children, sorted = false, sortDirection, onClick }) => {
	return (
		<th className={classNames(styles.SortableTableHeader, styles.SortableTableHeader___noPadding)}>
			<button
				onClick={onClick}
				className={classNames([
					styles.SortableTableHeader_button,
					compact && styles.SortableTableHeader_button___compact,
					sorted && styles.SortableTableHeader_button___sorted,
					sorted && sortDirection === SortDirection.Ascending && styles.SortableTableHeader_button___ascending,
					sorted && sortDirection === SortDirection.Descending && styles.SortableTableHeader_button___descending,
				])}
				type="button"
			>
				{children}
			</button>
		</th>
	);
};
